import { For } from 'solid-js';
import { advantages } from '~/data/categories';
import './WhyUs.css';

export function WhyUs() {
  return (
    <section class="section why">
      <div class="container">
        <div class="section-head" data-reveal>
          <div class="eyebrow">Почему выбирают нас</div>
          <h2>Прозрачный процесс, проверенные поставщики, реальные сроки</h2>
          <p class="section-head__lead">
            Никаких «выясним и перезвоним через неделю». Подбор за 1 рабочий день,
            фиксированные условия гарантии и доставка в любую точку России.
          </p>
        </div>

        <div class="why__grid">
          <For each={advantages}>
            {(adv, i) => (
              <article class="why__card" data-reveal style={`--delay:${i() * 50}ms`}>
                <span class="why__num">0{i() + 1}</span>
                <h3 class="why__title">{adv.title}</h3>
                <p class="why__desc">{adv.description}</p>
              </article>
            )}
          </For>
        </div>
      </div>
    </section>
  );
}
